import { render, staticRenderFns } from "./SchoolPlanCallout.vue?vue&type=template&id=5f56355e&scoped=true"
import script from "./SchoolPlanCallout.vue?vue&type=script&setup=true&lang=ts"
export * from "./SchoolPlanCallout.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SchoolPlanCallout.vue?vue&type=style&index=0&id=5f56355e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f56355e",
  null
  
)

export default component.exports